export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
}

export function formatPercent(value: number): string {
  return (value * 100).toFixed(2) + '%';
}

/** A return multiple as the exhibit prints it, e.g. 5.17x. */
export function formatMultiple(value: number): string {
  return value.toFixed(2) + 'x';
}

export function formatCompactCurrency(value: number): string {
  if (!value) return '—';
  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 1,
  }).format(value);
}

export function formatChartCurrency(value: number): string {
  const abs = Math.abs(value);
  if (abs >= 1_000_000) {
    const m = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value / 1_000_000);
    return `$${m}M`;
  }
  if (abs >= 1_000) return `$${(value / 1_000).toFixed(0)}K`;
  return `$${value.toFixed(0)}`;
}
